import React from "react";
import ReviewStep from "./ReviewStep";
import { useOnboarding } from "context/OnboardingContext";

const AddressReviewPage = () => {
  const { claimMeta } = useOnboarding();
  const claimLabel = claimMeta?.claim_type === "build_device"
    ? "Build + Device"
    : claimMeta?.claim_type === "device"
    ? "Device"
    : "Build";

  return (
    <ReviewStep
      stepKey="address"
      title={`${claimLabel} Address`}
      fields={[
        { name: "address_line_1", label: "Address Line 1" },
        { name: "city", label: "City" },
        { name: "state", label: "State" },
        { name: "zip", label: "ZIP Code" },
      ]}
    />
  );
};

export default AddressReviewPage;
